import store from '@/store'
import axios from 'axios'
import base from '@/__vue2stone/service/wasaapi/v1/__base'

export default {
  async index() {
    const factoryId = store.state.app.factory.id;
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'locale',
      params: {
        factory: factoryId,
      }
    });
    return res;
  },
  async setLocalesFromAPI() {
    try {
      const res = await axios.get('locale')
      store.dispatch('locale/setLocales', res.data.data);
    } catch (err) {
      alert(this.message['index locale error.']);
    }
  }
}